import PartialProfileFirstNameConflictModal from './PartialProfileFirstNameConflictModal';

export default PartialProfileFirstNameConflictModal;
